import { AldenService } from "./alden.service";
import { Injectable } from "@angular/core";
import { TranslationService, UserPreferencesService } from "@alfresco/adf-core";
import { BehaviorSubject } from "rxjs";
import { DEFAULT_CONFIG_PROP, DEFAULT_SEARCH_PROP } from "../models/alden-constants";
import { SMTConfirmDialogComponent } from "../dialogs/confirm/confirm.dialog";
import { MatDialog } from "@angular/material/dialog";
import { CustomDataColumn, CustomViewerConfig } from "../models/custom-viewer-config";
import { ExtensionService } from "@alfresco/adf-extensions";

@Injectable()
export class CustomUserPreferencesService {

  viewerId: string = "";
  columns: CustomDataColumn[] | undefined;

  appliedValues: Record<string, any> = {};

  private selectedSearchSubject = new BehaviorSubject<any | undefined>(undefined);
  selectedSearch$ = this.selectedSearchSubject.asObservable();

  private defaultColumnsSet = new BehaviorSubject<CustomDataColumn[] | undefined>(undefined);
  defaultColumnsSet$ = this.defaultColumnsSet.asObservable();

  constructor(private aldenService: AldenService, private usersPreferenceService: UserPreferencesService, private dialog: MatDialog,
    private translationService: TranslationService, private extensions: ExtensionService) { }

  pushAppliedValue(key: string, value: any) {
    this.appliedValues[key] = value;
  }

  getCurrentSearchValues(): any {
    return JSON.stringify(this.appliedValues);
  }

  clearAppliedValues() {
    this.appliedValues = {};
  }

  deleteFromAppliedValues(key: string) {
    delete this.appliedValues[key];
  }


  /**
   * Este método se encarga de buscar en la carpeta que contiene las búsquedas,
   * si no existe la crea
   * @param viewer Nombre del visor para el que se va a guardar o cargar la búsqueda
   * @returns Id del Nodo carpeta
   */
  async loadSearchFiles(viewer: string) {
    /*const savedSearchFolder = await this.getSavedSearchFolderForViewer(viewer);

    if (savedSearchFolder == undefined){
        this.store.dispatch(new SnackbarErrorAction('ALDEN.MESSAGES.ERRORS.NO_HOMEFOLDER'));
        return [];
    }

    const result: NodeChildAssociationPaging = await this.aldenService.getChildren(savedSearchFolder);
    return result?.list?.entries?.filter(item => item.entry.nodeType === CM_CONTENT && item.entry.name.toLowerCase().endsWith(SEARCH_FILE_SUFFIX));*/

    const postBody = {};
    const queryParams = {};
    const formParam = {};
    const headerParams = {};
    const contentTypes = ['multipart/form-data'];
    const accepts = ['application/json'];
    const url = `/smtecno/ssm/utils/search?viewer=${viewer}`;

    return this.aldenService.callAlfresco(url, 'GET', queryParams, headerParams, formParam, postBody, contentTypes, accepts);
  }

  /**
* Crea un nodo de búsqueda guardada.
*
* Este método realiza una solicitud POST a la API de Alfresco para subir el documento.
* Acepta un parámetro `formParam` que contiene los datos del formulario, y devuelve una promesa
* con el resultado de la operación.
*
* @param formParam Objeto que contiene los datos del formulario a subir.
* @returns Promise<any> Promesa que se resuelve con el resultado de la operación de subida.
*/
  uploadSavedSearch(postBody: any): Promise<any> {
    const formParam = {};
    const queryParams = {};
    const headerParams = {};
    const contentTypes = ['application/json'];
    const accepts = ['application/json'];
    const url = '/smtecno/ssm/utils/search';

    return this.aldenService.callAlfresco(url, 'POST', queryParams, headerParams, formParam, postBody, contentTypes, accepts);
  }

  saveViewerConfigForUser(postBody: any) {
    const dialogRef = this.dialog.open(SMTConfirmDialogComponent, {
      data: {
        title: 'ALDEN.DIALOGS.SAVE_VIEWER_CONFIG.CONFIRM_DIALOG.TITLE',
        message: 'ALDEN.DIALOGS.SAVE_VIEWER_CONFIG.CONFIRM_DIALOG.MESSAGE',
        htmlContent: this.translationService.instant('ALDEN.DIALOGS.SAVE_VIEWER_CONFIG.CONFIRM_DIALOG.MESSAGE'),
        noLabel: 'ALDEN.DIALOGS.SAVE_VIEWER_CONFIG.CONFIRM_DIALOG.NO_LABEL',
        yesLabel: 'ALDEN.DIALOGS.SAVE_VIEWER_CONFIG.CONFIRM_DIALOG.YES_LABEL',
      },
      minWidth: '250px'
    });

    return new Promise((resolve) => {
      dialogRef.afterClosed().subscribe(async (result) => {
        if (result) {
          const id = JSON.parse(await this.saveViewerConfig(postBody)).id;
          this.usersPreferenceService.set(this.viewerId + DEFAULT_CONFIG_PROP, id);
          resolve(true);
        } else
          resolve(false);
      });
    });
  }

  saveViewerConfig(postBody: any) {
    const formParam = {};
    const queryParams = {};
    const headerParams = {};
    const contentTypes = ['application/json'];
    const accepts = ['application/json'];
    const url = '/smtecno/ssm/utils/config/viewer';

    return this.aldenService.callAlfresco(url, 'POST', queryParams, headerParams, formParam, postBody, contentTypes, accepts);
  }


  setSelectedSearch(search: any): void {
    this.selectedSearchSubject.next(search);
  }

  setDefaultColumns(cols: CustomDataColumn[]): void {
    this.defaultColumnsSet.next(cols);
  }

  setDefaultSearch(defaultSearchId: string) {
    this.usersPreferenceService.set(this.viewerId + DEFAULT_SEARCH_PROP, defaultSearchId);
  }

  getDefaultSearch() {
    return this.usersPreferenceService.get(this.viewerId + DEFAULT_SEARCH_PROP);
  }

  unsetDefaultConfig() {
    return this.usersPreferenceService.set(this.viewerId + DEFAULT_CONFIG_PROP, "");
  }
  
  getDefaultConfig() {
    return this.usersPreferenceService.get(this.viewerId + DEFAULT_CONFIG_PROP);
  }

  setViewerId(viewerId: string) {
    this.viewerId = viewerId;
  }

  loadConfiguration(viewerConfig: CustomViewerConfig){
    this.columns = (viewerConfig.columns || []).filter((column) => (!column.visible || column.visible == "true" || (column.visible != "false" && this.extensions.evaluateRule(column.visible))));
  }

  getColumns(): CustomDataColumn[]{
    return this.columns!!;
  }
}